import { createActions, createReducer } from 'reduxsauce';
import { ICustomer } from 'models/Customer';

export const { Types, Creators } = createActions({
  setOpenProtocolCustomer: ['data'],
});

const INITIAL_STATE: ICustomer = {};

const setOpenProtocolCustomer = (_state = INITIAL_STATE, action: any) => ({
  ...action.data,
});

export default createReducer(INITIAL_STATE, {
  [Types.SET_OPEN_PROTOCOL_CUSTOMER as any]: setOpenProtocolCustomer,
});
